import React from "react";

import RefreshIndicator from "./RefreshIndicator";

interface IPullToRefreshState {
  busy: boolean;
  touchStart: any;
  drag: number;
  dragging: boolean;
}

const initialState = {
  busy: false,
  touchStart: null,
  drag: 0,
  dragging: false,
};

export interface IPullToRefreshProps {
  children: React.ReactNode;
  dragMultiplier?: number;
  maxDrag?: number;
  indicatorSize?: number;
  onRefresh: () => void;
  style: any;
  topOffset?: number;
}

export default class PullToRefresh extends React.Component<
  IPullToRefreshProps,
  IPullToRefreshState
> {
  static defaultProps = {
    children: null,
    dragMultiplier: 0.75,
    indicatorSize: 40,
    maxDrag: 350,
    style: {},
    topOffset: 0,
  };

  state = initialState;

  onTouchStart = (event: any) => {
    //@ts-ignore
    if (!this.state.busy && this.el.scrollTop <= this.props.topOffset) {
      this.setState({
        touchStart: event.touches[0],
      });
    }
  };

  onTouchMove = (event: any) => {
    if (!this.state.touchStart) {
      return;
    }
    const drag = Math.max(
      0,
      //@ts-ignore
      event.touches[0].clientY - this.state.touchStart.clientY
    );
    if (drag !== 0) {
      this.setState({
        //@ts-ignore
        drag: Math.min(drag, this.props.maxDrag),
        dragging: true,
      });
    } else if (!this.state.dragging) {
      this.reset();
    }
  };

  onTouchEnd = () => {
    const { maxDrag, onRefresh } = this.props;
    if (!this.state.busy) {
      //@ts-ignore
      if (this.state.drag >= maxDrag * 0.9) {
        this.setState({
          busy: true,

          //@ts-ignore
          drag: this.props.maxDrag / 2,
          touchStart: null,
        });
        Promise.resolve().then(onRefresh).then(this.reset, this.reset);
      } else {
        this.reset();
      }
    }
  };

  ref = (element: any) => {
    //@ts-ignore
    this.el = element;
  };

  reset = () => {
    this.setState(initialState);
  };

  render() {
    const {
      children,
      dragMultiplier,
      indicatorSize,
      maxDrag,
      onRefresh,
      style,
      topOffset,
      ...props
    } = this.props;
    return (
      <div
        {...props}
        ref={this.ref}
        style={{
          ...style,
          overflowY: this.state.dragging ? "hidden" : "scroll",
        }}
        onTouchStart={this.onTouchStart}
        onTouchMove={this.onTouchMove}
        onTouchEnd={this.onTouchEnd}
      >
        <RefreshIndicator
          busy={this.state.busy}
          //@ts-ignore
          size={indicatorSize}
          //@ts-ignore
          drag={this.state.drag * dragMultiplier}
        />
        {children}
      </div>
    );
  }
}
